/* eslint-disable prettier/prettier */

/**
 * This file will represent the final output needed to run app.
 */
import { curriculumProgressInitialState } from './curriculumProgress';
import { cravingsTabInitialState } from './dailySummaries';
import { overviewInitialState } from './overview';
import { rewardListInitialState } from './rewardList';
import { usageReportInitialState } from './usageReport';
import { treatmentSummary } from './treatmentSummary';
import { patientInfo } from './patientInfo';

export const compiledAppState = {
  patientId: patientInfo.id,
  selectedAccessRight: patientInfo.accessRights[0],
  selectedArId: patientInfo.accessRights[0].id,
  overview: overviewInitialState,
  rewardList: rewardListInitialState,
  usageReport: usageReportInitialState,
  dailySummaries: cravingsTabInitialState,
  curriculumProgress: curriculumProgressInitialState,
  treatmentSummary: treatmentSummary,
  patientInfo: patientInfo,

  // Dispatchers
  setSelectedAccessRight: () => {},
  setSelectedArId: () => {},
  setOverview: () => {},
  setRewardList: () => {},
  setUsageReport: () => {},
  setCurriculumProgress: () => {},
  setDailySummaries: () => {},
  setTreatmentSummary: () => {},
  setPatientInfo: () => {},
};
